/**
 * Find and track current accommodation from list
 * Watches accommodations data and selected ID to return current accommodation
 */

import { ref, watchEffect, type Ref } from 'vue'
import { selectedAccommodationId } from '@/layouts/queries'

import type { Accommodation } from '@/types/models'

/**
 * Get current selected accommodation from list
 * @param accommodationsData - Reactive list of accommodations
 * @returns Reactive reference to current accommodation
 */
export function useCurrentAccommodation(
  accommodationsData: Ref<Accommodation[] | undefined>
): Ref<Accommodation | null | undefined> {
  const current = ref<Accommodation | null | undefined>(null)

  watchEffect(() => {
    current.value = accommodationsData.value?.find(
      accommodation => Number(accommodation.accommodationId) === Number(selectedAccommodationId.value)
    )
  })

  return current
}